export function isValidFileType(file: File, accept: string): boolean {
  if (!accept) {
    return true;
  }

  const acceptTypes = accept.split(',').map((type) => type.trim());

  return acceptTypes.some((acceptType) => {
    // Handle MIME types (e.g., "image/*", "text/plain", "application/pdf")
    if (acceptType.includes('/')) {
      if (acceptType.endsWith('/*')) {
        // Wildcard MIME type (e.g., "image/*")
        const baseType = acceptType.slice(0, -2);
        return file.type.startsWith(baseType);
      } else {
        // Exact MIME type match
        return file.type === acceptType;
      }
    }

    // Handle file extensions (e.g., ".jpg", ".pdf", ".txt")
    if (acceptType.startsWith('.')) {
      const fileName = file.name.toLowerCase();
      return fileName.endsWith(acceptType.toLowerCase());
    }

    // Handle extension without dot (e.g., "jpg", "pdf")
    const fileName = file.name.toLowerCase();
    return fileName.endsWith(`.${acceptType.toLowerCase()}`);
  });
}
